import { type ResolvedContextData } from '@common/defaults/ContextData';
import { WidgetType } from '@common/types/Sidebar';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'podcast.title',
    type: WidgetType.LATEST_PODCASTS,
};

export const Widget = ({ contextData, dataList }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    return (
        <SimpleWidget contextData={contextData} title={title}>
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem key={i} contextData={contextData} {...data} />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
